module.exports = __webpack_public_path__ + "img/9.f60d6d3c.png";